import React from 'react';
import X from './X/index.js';
import Y from './Y/index.js';

/* eslint-disable jsx-a11y/no-distracting-elements */
const Axis = () => {
  return <marquee>use Axis.X/Axis.Y</marquee>;
};
/* eslint-enable jsx-a11y/no-distracting-elements */

Axis.displayName = 'Chart.Axis';

Axis.X = X;
Axis.Y = Y;

export default Axis;
export { X,Y };
export const {
  displayName
} = Axis;
